module.exports = __webpack_public_path__ + "img/fb_gold.1ff58d2c.png";